import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import WindowEvents from 'decorators/WindowEvents'
import Div from 'components/Div'

const DropdownWrapper = styled(Div)`
  position: relative;
  width: 100%;
`

const DefaultDropdownContainer = styled(Div)`
  position: absolute;
  top: calc(100% + 5px);
  width: 100%;
`

class Dropdown extends React.PureComponent {
  static propTypes = {
    registerEventListener: PropTypes.func.isRequired, // injected from WindowEvents
    // eslint-disable-next-line react/no-unused-prop-types
    show: PropTypes.bool,
    controlled: PropTypes.bool,
    DropdownContainer: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    renderLabel: PropTypes.func,
    renderDropdown: PropTypes.func,
    shouldCloseOnPageClick: PropTypes.bool,
    onClose: PropTypes.func, // callback invoke when dropdown is closed (i.e. this.state.show === false)
    onOpen: PropTypes.func, // callback invoke when dropdown is opened (i.e. this.state.show === true)
    onClosed: PropTypes.func, // callback invoked when dropdown animated out
    onOutsideClick: PropTypes.func
  }

  static defaultProps = {
    controlled: false,
    renderLabel: () => null,
    DropdownContainer: DefaultDropdownContainer,
    renderDropdown: () => null,
    shouldCloseOnPageClick: true,
    onClose: () => {},
    onOpen: () => {},
    onClosed: () => {},
    onOutsideClick: () => {}
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (!prevState || (nextProps.show !== prevState.show && prevState.controlled)) {
      return { show: nextProps.show }
    }
    return null
  }

  constructor (props) {
    super(props)
    this.state = {
      show: false,
      controlled: props.controlled
    }
    props.registerEventListener('mousedown', this.onPageClick)
  }

  onPageClick = (e) => {
    const { shouldCloseOnPageClick, onOutsideClick } = this.props
    const { show } = this.state
    if (shouldCloseOnPageClick && this._dropdownWrapper && !this._dropdownWrapper.contains(e.target)) {
      onOutsideClick(show)
      this.closeDropdown()
    }
  }

  showDropdown = () => {
    const { controlled } = this.state
    if (controlled) {
      this.props.onOpen()
    } else {
      this.setState({ show: true }, this.props.onOpen)
    }
  }

  closeDropdown = () => {
    const { controlled } = this.state
    if (controlled) {
      this.props.onClose()
    } else {
      this.setState({ show: false }, this.props.onClose)
    }
  }

  toggleDropdown = () => {
    const { show } = this.state
    if (show) {
      this.closeDropdown()
    } else {
      this.showDropdown()
    }
  }

  render () {
    const { DropdownContainer, renderLabel, renderDropdown, onClosed } = this.props
    const { show } = this.state
    return (
      <DropdownWrapper ref={(e) => { this._dropdownWrapper = e }}>
        {renderLabel({ toggleDropdown: this.toggleDropdown, showDropdown: this.showDropdown, closeDropdown: this.closeDropdown, isDropdownOpening: show })}
        <DropdownContainer show={show} onClosed={onClosed}>{renderDropdown({ showDropdown: this.showDropdown, closeDropdown: this.closeDropdown, isDropdownOpening: show })}</DropdownContainer>
      </DropdownWrapper>
    )
  }
}

export default WindowEvents(Dropdown)
